import { breakpoint, getSiblings, debounce } from '../../util/helpers';
import { setElementInert } from '../../util/a11y/handle-inert';
import SplitText from '../../util/greensock/SplitText';

export default {
  gridMax: 1280,
  desktopLarge: 1440,
  maxBreakpoint: 1920,
  init() {
    const toggles = document.querySelectorAll('.ms-tabbed-overview__list-header');

    if (!toggles.length) { return; }

    window.addEventListener('load', () => {
      this.resizeListener();

      this.splittedOverviewText = new SplitText('.ms-tabbed-overview__list-header .ms-tabbed-overview__list-item__text', { type: 'lines', linesClass: 'ms-tabbed-overview__list-item__split_text' });
      this.splitOverviewText();
      setTimeout(() => this.initWhiteLines(), 600);
      this.initListener(toggles);
    });
    window.addEventListener('resize', () => debounce(() => {
      this.splitOverviewText();
      this.resizeListener();
    }, 200));
  },
  resizeListener() {
    const innerContents = document.querySelectorAll('.ms-tabbed-overview__list-content');
    const baseWidth = window.innerWidth >= this.maxBreakpoint ? 1165 : 923;
    const marginAtDesktop = 428; // + 80px desktop offset
    const marginAtDesktopLarge = 514; // + 80px desktop offset
    const isLargeDesktop = window.innerWidth >= this.desktopLarge;
    const isGridMax = window.innerWidth >= this.gridMax;

    Array.from(innerContents).map(element => {
      if (window.innerWidth >= this.maxBreakpoint) {
        element.style.width = `${baseWidth}px`;
      } else if (window.innerWidth < 376){
        element.style.width = `${window.innerWidth - 35}px`;
      } else {
        element.style.width = `${baseWidth + ((window.innerWidth - (baseWidth + (isLargeDesktop ? marginAtDesktopLarge : (isGridMax ? marginAtDesktop : 728)))) / 2)}px`;
      }
    })
  },
  initWhiteLines() {
    // one-time run
    const tabHero = document.querySelector('.ms-tabbed-overview--hero');
    const activeHeader = document.querySelector('.ms-tabbed-overview__list-item--expanded .ms-tabbed-overview__list-header');
    if (!activeHeader) return;
     //select the first splitted text or the element itself if splitted is reverted
    const activeHeaderSpan = activeHeader.querySelector('.ms-tabbed-overview__list-item__text div') || activeHeader.querySelector('.ms-tabbed-overview__list-item__text');
    const whiteLine = activeHeader.querySelector('.tablet-line');

    if (this.desktopLarge > window.innerWidth && activeHeader && tabHero) {
      whiteLine.style.width = `calc(100% - ${(activeHeaderSpan.offsetWidth)}px)`;
    } else if (activeHeader) {
      whiteLine.style.width = `calc(100% - ${(activeHeaderSpan.offsetWidth)}px)`;
    }
  },
  initListener(toggles) {
    let cancelTimeout = 0
    toggles.forEach(toggle => {
      const toggleTabOverview = () => {
        clearTimeout(cancelTimeout);
        const parentContainer = toggle.parentElement;
        const header = parentContainer.querySelector('.ms-tabbed-overview__list-header');
        const content = parentContainer.querySelector('.ms-tabbed-overview__list-content');

        // if active item is clicked again
        if (parentContainer.classList.contains('ms-tabbed-overview__list-item--expanded')) {
          if (breakpoint() === 'mobile' ) {
            // remove the expanded class
            parentContainer.classList.remove('ms-tabbed-overview__list-item--expanded');

            // set the button's expanded state
            header.setAttribute('aria-expanded', 'false');
            // hide the content to SR
            setElementInert(true, content);
          }
        } else {
          // normal click
          parentContainer.classList.add('ms-tabbed-overview__list-item--expanded');
          header.setAttribute('aria-expanded', 'true');
          setElementInert(false, content);
        }

        // close others
        getSiblings(parentContainer).forEach((sibling) => {
          const siblingHeader = sibling.querySelector('.ms-tabbed-overview__list-header');
          const siblingContent = sibling.querySelector('.ms-tabbed-overview__list-content');
          sibling.classList.remove('ms-tabbed-overview__list-item--expanded');
          setElementInert(true, siblingContent);
          siblingHeader.setAttribute('aria-expanded', 'false');
          const siblingWhiteLine = sibling.querySelector('.tablet-line');
          siblingWhiteLine.style.width = 0;
        });

        cancelTimeout = setTimeout(() => {
          this.splitOverviewText();
          this.initWhiteLines();
        }, 300);
      };

      // VO clicks this element no matter what. 🤔
      // In that case, let's just redirect the click event to the main event handler.
      // This element is set as inert in the FE, it cannot be clicked manually
      // Events passing here are purely from VO interactions
      const toggleBtn = toggle.querySelector('.ms-tabbed-overview__list-button')

      // sanity check
      if (toggleBtn) { toggleBtn.addEventListener('click', toggleTabOverview); }

      // Normal mouse click and mouseenter (desktop)
      toggle.addEventListener('click', toggleTabOverview);
      toggle.addEventListener('mouseenter', toggleTabOverview);
    });
  },
  splitOverviewText() {
    if (breakpoint() === 'mobile') {
      this.splittedOverviewText.revert();
    } else {
      this.splittedOverviewText.split();
    }
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/tabbedOverview.js